import type { ChatController } from "../lib/useChat.ts";
import { ChatHistory } from "./ChatHistory.tsx";

/**
 * Chat History as its own panel (a left or right slot, independent of the Agent). It renders the SAME controller as the
 * Agent panel (one source of truth for sessions, no duplicated state or fetching): selecting a chat here opens it in
 * the Agent; closing the panel returns History to the Agent, where the normal history controls are always available.
 */
export function HistoryPanel({
  controller,
  onPicked,
}: {
  controller: ChatController;
  /** Narrow screens only: after choosing (or starting) a chat, go back to the Agent view. */
  onPicked?: () => void;
}) {
  const { chat, sessions, open, newChat, remove } = controller;
  const running = chat.activeRunId !== null;
  return (
    <div className="history-panel" data-testid="history-panel">
      <div className="pane-head">
        <span className="pane-title">History</span>
      </div>
      <ChatHistory
        sessions={sessions}
        activeId={chat.sessionId}
        runningId={running ? chat.sessionId : null}
        onSelect={(id) => {
          void open(id);
          onPicked?.();
        }}
        onDelete={async (id) => void (await remove(id))}
        onNew={() => {
          newChat();
          onPicked?.();
        }}
      />
    </div>
  );
}
